import { debounce } from "./utils";

function fixedHeader(mqList, mqMinWidth) {

  const header = document.querySelector('.ne-header');
  const headerWrapper = document.querySelector('.ne-header__wrapper');
  const nav = document.querySelector('.ne-nav');
  const subscribeButtons = document.querySelectorAll('.ne-header__menu-subscribe');
  const headerHeight = header.offsetHeight;
  const navHeight = nav.offsetHeight;
  const transformValue = (headerHeight - navHeight);

  let scrollPos = 0;

  function onScrollHeader(scrollPos) {
    header.style.minHeight = `${headerHeight}px`;

    // Fix the header and hide from view
    if(scrollPos > headerHeight) {
      headerPreAnimated();
    };

    // 50px threshold until animate the header slide in
    if (scrollPos > headerHeight + 50) {
      headerAnimated();
    };

    // Remove fixed header classes and styles
    if (scrollPos < headerHeight) {
      headerDefault();
    };
  };

  function headerPreAnimated() {
    headerWrapper.classList.add('ne-header__wrapper--pre-animated');
    headerWrapper.style.transform = `translateY(-${transformValue}px)`;
    nav.classList.add('ne-nav--pre-animated');
    nav.style.maxHeight = 0;

  };

  function headerAnimated() {
    headerWrapper.classList.remove('ne-header__wrapper--pre-animated');
    headerWrapper.classList.add('ne-header__wrapper--animated');
    nav.style.maxHeight = `${navHeight}px`;
    nav.classList.remove('ne-nav--pre-animated');
    nav.classList.add('ne-nav--animated');
    subscribeButtons.forEach(btn => {
      btn.classList.add('ne-header__menu-subscribe--animated');
    });
  };

  function headerDefault() {
    headerWrapper.classList.remove('ne-header__wrapper--pre-animated', 'ne-header__wrapper--animated');
    headerWrapper.removeAttribute('style');
    nav.classList.remove('ne-nav--pre-animated', 'ne-nav--animated');
    nav.removeAttribute('style');
    subscribeButtons.forEach(btn => {
      btn.classList.remove('ne-header__menu-subscribe--animated');
      btn.firstChild.removeAttribute('style');
    });
  };

  function stripAttributes() {
    header.removeAttribute('style');
    headerWrapper.classList.remove('ne-header__wrapper--pre-animated', 'ne-header__wrapper--animated');
    headerWrapper.removeAttribute('style');
    nav.classList.remove('ne-nav--pre-animated', 'ne-nav--animated');
    nav.removeAttribute('style');
    subscribeButtons.forEach(btn => {
      btn.removeAttribute('style');
      btn.classList.remove('ne-header__menu-subscribe--animated');
    });
  }
  
  const scrollDebounce = debounce(() => {
    
    const screenWidth = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
    // Check that scrensize hasnt changed to mobile before executing animation functions
    if (screenWidth >= mqMinWidth) {

      scrollPos = window.scrollY;
      window.requestAnimationFrame(onScrollHeader.bind(null, scrollPos));
    };
  }) 

  window.addEventListener('scroll', scrollDebounce, {passive: true});

  // Remove header style attribute if width changes to mobile to avoid layout shift
  mqList.addListener(function(e) {

    if (!e.matches) {
      stripAttributes();
    } else {
      const scrollPos = window.scrollY;
      onScrollHeader(scrollPos);
    };
  });
};

document.addEventListener('DOMContentLoaded', function() {

  const screenWidth = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
  const mqMinWidth = 1180;
  const mqList = window.matchMedia(`(min-width: ${mqMinWidth}px)`);

  // Only call function if first load is at desktop width
  if (screenWidth >= mqMinWidth) {
    fixedHeader(mqList, mqMinWidth);
  };

  // Catch all for if site is loaded at mobile width first
  mqList.addEventListener('change', (e) => {
    if (!e.matches) return;
    fixedHeader(mqList, mqMinWidth);
  });
});
